import { render, staticRenderFns } from "./ClientProfileSettings.vue?vue&type=template&id=e33165f2&scoped=true&"
import script from "./ClientProfileSettings.vue?vue&type=script&lang=js&"
export * from "./ClientProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileSettings.vue?vue&type=style&index=0&id=e33165f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33165f2",
  null
  
)

export default component.exports